import { Request } from '@/classes/Request.ts'
import { Util } from '@/modules/util'

export interface Statement {
  id: number
  name: string
  districtName: string
  startDate: string
  endDate: string
  createdDate: string
}

export const listStatements = async (): Promise<Statement[]> => {
  return new Promise<Statement[]>(async resolve => {
    const response = await new Request().get('/ajax/documents/statements')
    resolve(
      response.data.statements.map((statement: any) => {
        return Util.Obj.keysToCamel(statement) as Statement
      })
    )
  })
}
